import { useFormik } from 'formik';
import { FunctionariesSwitch } from '../../../../../../shared/types/systemConfiguration/functionariesSwitch';
import { FunctionariesSwitchDataProps } from './props';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { asyncGetParams } from '../../../../../../services/param.service';
import { asyncGetCities } from '../../../../../../services/location.service';
import { initialValues, validationSchema } from './formData';

export const useFunctionariesSwitchData = ({
    data,
    onChangeData,
    onChangeFormik,
}: FunctionariesSwitchDataProps) => {
    const [areaOptions, setAreaOptions] = useState<ISelect[]>([]);
    const [positionOptions, setPositionOptions] = useState<ISelect[]>([]);
    const [cityOptions, setCityOptions] = useState<ISelect[]>([]);

    const onSubmit = (data: FunctionariesSwitch) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('surname', data?.surname || '');
        formik?.setFieldValue('email', data?.email || '');
        formik?.setFieldValue('phone', data?.phone || '');
        formik?.setFieldValue('extension', data?.extension || '');
        formik?.setFieldValue('active', data?.active ?? true);
        formik?.setFieldValue('description', data?.description || '');
        formik?.setFieldValue('area', (data?.area as ISelect)?.id || '');
        formik?.setFieldValue('city', (data?.city as ISelect)?.id || '');
        formik?.setFieldValue(
            'position',
            (data?.position as ISelect)?.id || ''
        );
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.FUNCTIONARIES_SWITCHBOARD_AREA).then((items) =>
            setAreaOptions(items)
        );

        asyncGetParams(ParamEnum.FUNCTIONARIES_SWITCHBOARD_POSITION).then(
            (items) => setPositionOptions(items)
        );
        asyncGetCities().then((cities) => setCityOptions(cities));
    }, []);

    return {
        formik,
        positionOptions,
        areaOptions,
        cityOptions
    };
};
